module.exports = __webpack_public_path__ + "media/images/icons/country_flags/bw-286ba8fe3cf0c8ae076bb0e5a2044e35.svg";